import { values } from 'lodash/fp';

export const mapReservationDto = (reservation: $TSFixMe) => {
    const {
        purpose,
        businessSegmentId,
        categoryId,
        channelNumber,
        customNightCost,
        endUtc,
        identifier,
        rateId,
        startUtc,
        voucherId,
        occupancyData,
    } = reservation;

    return {
        purpose,
        businessSegmentId,
        requestedCategoryId: categoryId,
        channelNumber,
        customNightCost,
        endUtc,
        identifier,
        rateId,
        startUtc,
        voucherId,
        occupancyData: values(occupancyData),
    };
};
